export const BASE_URL = "https://admin.sfisolutions.id/upload/";
// export const BASE_URL = "http://localhost/gadget/gadgetcare/upload/";
